<template>
  <div>
    <breadcrumb/>
    <post-list category="BBEE Calidad - Protocolo Fuera Oficina (Vacaciones/Licencia Médica)"></post-list>
  </div>
</template>

<script>
import PostList from "@/components/Posts/PostList";
import Breadcrumb from "@/components/General/Breadcrumb";
export default {
  components: {
    PostList,
    Breadcrumb
  }
};
</script>